var _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGooglePlayBadgeDe = function SvgGooglePlayBadgeDe(_ref) {
  var title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 135 40"
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 .8c2.316 0 4.2 1.884 4.2 4.2v30c0 2.316-1.884 4.2-4.2 4.2H5A4.205 4.205 0 01.8 35V5C.8 2.684 2.684.8 5 .8h125m0-.8H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.752c-2.352 0-4.27 1.788-4.27 4.253 0 2.449 1.918 4.253 4.27 4.253 2.352 0 4.27-1.804 4.27-4.253 0-2.465-1.918-4.253-4.27-4.253zm0 6.83c-1.289 0-2.4-1.063-2.4-2.577 0-1.53 1.111-2.578 2.4-2.578s2.4 1.047 2.4 2.578c0 1.514-1.111 2.577-2.4 2.577zm-9.314-6.83c-2.352 0-4.269 1.788-4.269 4.253 0 2.449 1.917 4.253 4.27 4.253 2.352 0 4.269-1.804 4.269-4.253 0-2.465-1.917-4.253-4.27-4.253zm0 6.83c-1.288 0-2.4-1.063-2.4-2.577 0-1.53 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.577-2.4 2.577zm-11.078-5.525v1.804h4.317c-.129 1.015-.467 1.756-.982 2.271-.629.629-1.612 1.322-3.335 1.322-2.659 0-4.737-2.143-4.737-4.801s2.078-4.801 4.737-4.801c1.434 0 2.48.564 3.254 1.288l1.273-1.272c-1.08-1.031-2.513-1.82-4.527-1.82-3.641 0-6.702 2.964-6.702 6.605 0 3.64 3.06 6.605 6.702 6.605 1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.22 0-.42-.032-.806-.097-1.128h-6.073zm45.308 1.401c-.354-.95-1.434-2.706-3.641-2.706-2.191 0-4.011 1.723-4.011 4.253 0 2.384 1.804 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.484.71-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.288l5.687-2.353-.193-.483zm-5.8 1.418c-.048-1.643 1.273-2.481 2.223-2.481.741 0 1.37.37 1.58.902l-3.803 1.579zM82.628 30h1.87V17.5h-1.87V30zm-3.06-7.298h-.065c-.419-.5-1.224-.95-2.24-.95-2.126 0-4.075 1.868-4.075 4.269 0 2.384 1.95 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.87 2.498-2.271 2.498-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.19 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693zm-2.143 5.88c-1.289 0-2.368-1.079-2.368-2.561 0-1.498 1.079-2.594 2.368-2.594 1.273 0 2.271 1.096 2.271 2.594 0 1.482-.998 2.561-2.271 2.561zm24.38-11.083h-4.47V30H99.2v-4.736h2.606c2.068 0 4.101-1.498 4.101-3.883s-2.033-3.882-4.101-3.882zm.049 6.025H99.2v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .97-.792 2.143-2.187 2.143zm11.532-1.795c-1.351 0-2.75.595-3.33 1.913l1.657.692c.354-.692 1.013-.917 1.705-.917.965 0 1.946.58 1.962 1.609v.128c-.338-.193-1.062-.482-1.946-.482-1.785 0-3.603.98-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.255 0 1.946-.562 2.38-1.222h.065v.965h1.801v-4.792c0-2.22-1.656-3.458-3.795-3.458zm-.226 6.851c-.61 0-1.463-.306-1.463-1.062 0-.964 1.061-1.334 1.978-1.334.82 0 1.206.177 1.705.418a2.262 2.262 0 01-2.22 1.978zm10.583-6.578l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.33 7.575-1.899 4.214h1.946l5.131-11.789h-2.075zM106.936 30h1.866V17.5h-1.866V30z",
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-badge-de_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8,
    y1: 33.29,
    x2: 5.017,
    y2: 16.508,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.435 7.538c-.29.308-.462.786-.462 1.405v22.116c0 .62.172 1.097.462 1.405l.074.072L22.9 20.147v-.292L10.51 7.465l-.074.073z",
    fill: "url(#google-play-badge-de_svg__a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-badge-de_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 33.834,
    y1: 21.999,
    x2: 9.637,
    y2: 21.999,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.028 24.278l-4.13-4.13v-.293l4.13-4.13.094.053 4.893 2.78c1.397.794 1.397 2.093 0 2.887l-4.893 2.78-.094.053z",
    fill: "url(#google-play-badge-de_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-badge-de_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 24.827,
    y1: 19.704,
    x2: 2.069,
    y2: -3.054,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.122 24.225L22.898 20 10.435 32.464c.461.488 1.222.548 2.078.061l14.609-8.3",
    fill: "url(#google-play-badge-de_svg__c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-badge-de_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 7.297,
    y1: 41.824,
    x2: 17.46,
    y2: 31.661,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.122 15.777l-14.609-8.3c-.856-.487-1.617-.427-2.078.061l12.463 12.463 4.224-4.224z",
    fill: "url(#google-play-badge-de_svg__d)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.029 24.132l-14.516 8.247c-.812.461-1.537.43-2.003.01l-.075.075.074.072c.467.42 1.192.451 2.004-.01l14.609-8.301-.093-.093z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.435 32.318c-.29-.308-.462-.786-.462-1.405v.146c0 .62.172 1.098.462 1.405l.075-.074-.075-.072zm21.58-11.019l-4.986 2.833.093.093 4.893-2.78c.698-.397 1.048-.92 1.048-1.444-.059.474-.415.938-1.048 1.298z",
    opacity: 0.12
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.513 7.623l19.502 11.08c.633.36.989.824 1.048 1.298 0-.523-.35-1.047-1.048-1.444L12.513 7.477c-1.397-.794-2.54-.134-2.54 1.466v.147c0-1.601 1.143-2.26 2.54-1.467z",
    opacity: 0.25,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.011 13.134c-.436 0-.807-.121-1.115-.365-.307-.243-.525-.584-.653-1.026l.704-.293c.178.631.545.946 1.097.946.358 0 .633-.115.826-.347.192-.232.289-.546.289-.943V7h.771v4.09c0 .653-.18 1.157-.54 1.512-.361.355-.82.532-1.379.532zm6.695-5.397h-2.732V9.64h2.464v.72h-2.464v1.903h2.732V13h-3.502V7h3.502v.737zM52.957 13h-.771V7.737H50.51V7h4.123v.737h-1.676V13zm2.313 0v-.805l3.193-4.458h-3.058V7h3.955v.805l-3.193 4.458h3.227V13H55.27zm7.274 0h-.771V7.737h-1.676V7h4.123v.737h-1.676V13zm4.66 0V7h2.17c.47 0 .876.155 1.22.465.343.31.515.7.515 1.169 0 .285-.074.536-.222.754a1.392 1.392 0 01-.591.495v.033c.296.1.539.274.73.52.189.246.284.53.284.854 0 .492-.18.9-.54 1.224a1.85 1.85 0 01-1.279.486h-2.287zm.771-3.428h1.399c.29 0 .524-.095.7-.289.176-.192.264-.403.264-.632s-.085-.44-.256-.628a.86.86 0 00-.674-.286h-1.433v1.835zm0 2.69h1.55a.92.92 0 00.721-.31.996.996 0 00.276-.679.968.968 0 00-.285-.674.975.975 0 00-.746-.306h-1.516v1.97zm7.877-4.525h-2.733V9.64h2.464v.72h-2.464v1.903h2.733V13h-3.503V7h3.503v.737zM77.059 13V7h.77v6h-.77z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })));
};
export default SvgGooglePlayBadgeDe;